import { LogoType } from './types';
export const WIX_BRAND_LOGO_URLS = {
    [LogoType.wixClassic]: '82f27b_c164d40f80854cf9bc14a8646b41610b~mv2.png',
    [LogoType.wixStudio]: '82f27b_113deb0e8a0044e4b85bb7c1910df1a1~mv2.png',
};
//# sourceMappingURL=wix-brand-logos.js.map